<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Resultado de Citas</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row" id="formulario">
              <div class="col-3"></div>
              <div class="col-1"><b>Horario:</b></div>
              <div class="col-2" style="padding-left:0px;padding-right:15px;">
                <select class="form-control" v-model="Hora">
                  <option v-for="Horario in HorariosDisponibles" :value="Horario.value">{{Horario.content}}</option>
                </select>
              </div>
              <div class="col-1"><b>Fecha:</b></div>
              <div class="col-2" style="padding-left:0px;padding-right:15px;"><input type="date" v-model="FechaInicial" class="form-control" v-on:keyup.enter="filtrarCitas" @change="buscarCitas" /></div>
              <div class="col-3" style="padding-left:0px;padding-right:1px;"><input type="text" v-model="nombreBusqueda" class="form-control" placeholder="Buscar" v-on:keyup.enter="filtrarCitas" /></div>

            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2"><input type="button" class="form-control" @click="filtrarCitas" value="Buscar"></div>
            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2"><input type="button" class="form-control" @click="generarReporte" value="Generar Reporte" v-if="Citas.length > 0"></div>
            </div>
            <div class="row" id="tabla" style="margin-top:20px;">
              <table class="table table-striped table-light table-hover" id="tablaCitas">
                <thead class="thead-dark">
                  <tr class="visible-element">
                    <th>Folio <i class="fa fa-redo" @click="buscarCitas"></i></th>
                    <th>Datos del Solicitante</th>
                    <th>Trámites y Expedientes</th>
                    <th>Fecha y Hora</th>
                    <th>Notas del Solicitante</th>
                    <th v-if="MuestraCitasDeHoy">Cita Atendida</th>
                  </tr>
                </thead>
                <tbody class='text-dark'>
                  <tr v-for="Cita in Citas">
                    <td>{{Cita.CitaId}}</td>
                    <td>{{Cita.InformacionDeSolicitante.NombreCompleto}}<br />{{Cita.InformacionDeSolicitante.Telefono}}<br />{{Cita.InformacionDeSolicitante.CorreoElectronico}}</td>
                    <td>
                      <ul>
                        <template v-for="Tramite in Cita.TramitesCita">
                          <li>{{Tramite.TipoTramite.Nombre}}.</li>
                          <li style="list-style-type:none"><ul> <li v-for="Expediente in Tramite.Expedientes"> {{Expediente.TipoDocumento_DBPJ.Nombre}} - {{Expediente.NumeroDeExpediente}} </li></ul></li>
                        </template>
                      </ul>

                    </td>
                    <td>{{Cita.AgendaBloque.FechaHoraString}}</td>
                    <td>{{Cita.NotasDelSolicitante}}</td>
                    <td v-if="MuestraCitasDeHoy">
                      <i class="fas fa-check-circle fa-2x" @click="MarcarCitaAtendida(Cita.CitaId,true,0)" />
                      <i class="fas fa-times-circle fa-2x" @click="MarcarCitaAtendida(Cita.CitaId,false,0)" />
                      <i class="fas fa-plus-circle fa-2x" @click="pedirConfirmacion(Cita.CitaId)" />
                    </td>
                  </tr>
                  <tr v-if="Citas.length == 0"><td colspan="5">No se encontraron citas pendientes en los siguientes 5 días hábiles.</td></tr>
                </tbody>
              </table>
            </div>
            <div class="modal fade"
                 id="modalConfirmacion"
                 tabindex="-1"
                 role="dialog"
                 aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="tituloModalConfirmacion">Añadir trámites adicionales</h5>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <h5>
                      <span id="cuerpoModalConfirmacion"
                            class="col-form-label">¿Cuántos trámites desea añadir?</span>
                    </h5>
                    <br />

                    <input class="form-control" type="number" min="0" max="10" v-model="tramitesAdicionales" />
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"> Cancelar </button>
                    <button type="button" class="btn btn-primary" id="botonModalConfirmacion" @click="MarcarCitaAtendida(CitaIdAux,true,tramitesAdicionales)" data-dismiss="modal"> Añadir </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        nombreBusqueda: "",
        Citas: [],
        _Citas: [],
        NumeroFilasPagina: 10,
        FechaInicial: null,
        Hoy: null,
        HorariosDisponibles: [{ "content": "Todo el día.", "value": null }],
        Hora: null,
        MuestraCitasDeHoy: true,
        FechaBusqueda: null,
        tramitesAdicionales: 0,
        CitaIdAux: 0
      }
    },
    components: {
    },
    methods: {
      MarcarCitaAtendida: function (citaId, asistioSolicitante, tramitesAdicionales) { //Marca una cita como atendida o no atendida
        var peticion = {
          "esPrueba": false,
          "CitaId": citaId,
          "AsistioSolicitante": asistioSolicitante,
          "TramitesAdicionales": tramitesAdicionales
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.MarcarCitaAtendida, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.removerCita(citaId);
            comun.mensajeDeAlerta("Resultado de cita registrado exitosamente.", null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },

      buscarCitas: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "esPrueba": false,
          "NombreBusqueda": "",
          "EstatusCitaId": 2,
          "Notificadas": 1,
          "FechaInicial": this.FechaInicial,
          "FechaFinal": null,
          "Hora": this.Hora,
          "CargarSoloExpedientesDisponibles": true
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCitas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.MuestraCitasDeHoy = (this.FechaInicial == this.Hoy);
            this.FechaBusqueda = this.FechaInicial
            //console.log(response)

            this._Citas = response.data.Citas
            //console.log(this.Citas, this._Citas)
            this.filtrarCitas();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      removerCita: function (citaId) {
        var indice = -1;

        this._Citas.forEach(function (cita, index) {
          if (cita.CitaId == citaId) {
            indice = index;

          }
        });
        if (indice > -1) {
          this._Citas.splice(indice, 1);
        }
        this.Citas = this._Citas;
        this.filtrarCitas();
      },
      filtrarCitas: function () {
        //alert('filtrando');
        if (this.nombreBusqueda) {
          //alert('cool');
          let textoBusqueda = this.nombreBusqueda.toUpperCase();
          this.Citas = this._Citas.filter(cita => cita.InformacionDeSolicitante.NombreCompleto.toUpperCase().includes(textoBusqueda) || this._busquedaNumeroExpedienteCita(cita, textoBusqueda))
        } else {
          this.Citas = this._Citas
        }
      },
      _busquedaNumeroExpedienteCita(cita, textoBusqueda) {
        //console.log(cita)
        for (let tramiteCita of cita.TramitesCita) {
          for (let expediente of tramiteCita.Expedientes) {
            if (expediente.NumeroDeExpediente.includes(textoBusqueda)) { return true; }
          }
        }
        return false;
      },
      llenarListaHorariosDisponibles: function () {//Genera un listado de las horas de las 08:00 a las 14:00
        var i;
        var text;
        var value;
        for (i = 8; i < 14; i++) {
          if (i < 10) {
            text = "0" + i + ":00";
            value = text + ":00";
            if (i < 9) {
              text += "- 0" + (i + 1) + ":00";
            } else {
              text += "- " + (i + 1) + ":00";
            }
          }
          else {
            value = i + ":00:00"
            text = i + ":00 - " + (i + 1) + ":00";
          }

          this.HorariosDisponibles.push({ "content": text, "value": value });
        }
      },
      fijarFecha: function () { //Almacena en una variable el día en curso
        var date = new Date();
        this.FechaInicial = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
          .toISOString()
          .split("T")[0];
        this.Hoy = this.FechaInicial;
      }, generarReporte: function () { //Muestra la tabla de citas en un archivo pdf

        var popupWin = window.open('', '_blank', 'location=no,left=100px');
        popupWin.document.open();
        popupWin.document.write('<html><head><title>Agenda de Citas</title>');
        popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
        popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
        popupWin.document.write('<style> tr { border-bottom: 2px solid ; }</style>')
        popupWin.document.write('</head><body >')
        popupWin.document.write('<h2>Agenda de Citas ' + this.FechaBusqueda + '</h2>')

        popupWin.document.write('<table class="table table-striped table-light table-hover" id="tablaCitas">')
        var resultados = document.getElementById('tablaCitas').innerHTML;
        resultados = resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        resultados = resultados.split('style="opacity: 0; display: none;"').join('style="opacity: 1; display: table-row;"');

        popupWin.document.write(resultados);
        popupWin.document.write('</table>');
        popupWin.document.write('</body></html>');
        /*var css = '@page { size: landscape; }',
          head = popupWin.document.head || document.getElementsByTagName('head')[0],
          style = popupWin.document.createElement('style');

        style.type = 'text/css';
        style.media = 'print';

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(popupWin.document.createTextNode(css));
        }

        head.appendChild(style);
        */
        setTimeout(function () { popupWin.print(); }, 1000)
        popupWin.document.close();
        popupWin.focus();
        this.ImpresionConcluida = true;
      },
      pedirConfirmacion: function (citaId) {//Abre un modal que solicita la cantidad de trámites adicionales a la cita en caso de haberlos
        this.CitaIdAux = citaId;
        $("#modalConfirmacion").modal();

      },
      paginarTabla: function (idTabla) {
        this.$nextTick(() => {
          PaginarTabla(idTabla, this.NumeroFilasPagina)
        })
      }
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      this.llenarListaHorariosDisponibles();
      this.fijarFecha();
      this.buscarCitas();
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fa, .fas button {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/ResultadoDeCitas/ResultadoDeCitas.vue